import {PageTypes} from './types';
import {useCurrentPageType} from './PageTypeContext';
import {useDeleteQueryParams} from './useDeleteQueryParams';
import {useLocation} from './useLocation';
import {useQueryParams} from './useQueryParams';

const pageTypesWherePageParamsAreDeprecated = [
  'category',
  'categoryLegacy',
  'brandShop',
  'brandLegacy',
] as PageTypes[];

export const usePageParamsRedirectUrls = () => {
  const {pathname} = useLocation();
  const pageType = useCurrentPageType();
  const queryParams = useQueryParams();
  const deleteQueryParams = useDeleteQueryParams();

  const containsDeprecatedPageParam =
    pageType &&
    pageTypesWherePageParamsAreDeprecated.includes(pageType) &&
    !!queryParams.get('page');

  if (containsDeprecatedPageParam) {
    const updatedUrlParams = deleteQueryParams('page');
    const updatedUrl = `${pathname}${
      updatedUrlParams.toString().length ? `?${updatedUrlParams}` : ''
    }`;

    return updatedUrl;
  }

  return undefined;
};
